import { CircularProgress } from "@material-ui/core";
import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Utils from '@/common/utils/utils';
import WarningIcon from '@material-ui/icons/WarningTwoTone';
import crypto from 'crypto-js';
import Constant from '@/common/constant/Constant';
export const FileUploaded = (props) => {
    function LinearProgressWithLabel(propProgress) {
        let process = propProgress.value ? Math.round(propProgress.value) : 0;
        return process < 100 ? (
            <Box display="flex" alignItems="center" style={{ marginTop: 2 }}>
                <Box width="100%" mr={1} minWidth={50}>
                    <LinearProgress variant="determinate" color="secondary" {...propProgress} />
                </Box>
                <Box minWidth={35}>
                    <Typography variant="body2" color="secondary">{`${process}%`}</Typography>
                </Box>
            </Box>
        ) : null;
    }

    function renderFileUpload() {
        let fileActive = true;
        let fileNameClass = props.isAlignLeft ? 'file-upload-name' : 'file-upload-name--change';
        const lastDot = props.chatPost.content.lastIndexOf('.');
        let fileExtention = ''
        let fileName
        if(props.chatPost.content.substring(0, lastDot).length === 0){
           fileName = props.chatPost.content.length > 50 ?  props.chatPost.content.slice(0,50) + '...' :  props.chatPost.content;
        }else{
            fileExtention = props.chatPost.content.substring(lastDot + 1);
            fileName = props.chatPost.content.substring(0, lastDot).length > 50 ?  props.chatPost.content.substring(0, lastDot).slice(0,50) + '...' : props.chatPost.content.substring(0, lastDot)+'.' ;
        } 

        let renderUploadFiles = [];
        const fileNameAndSize = `${fileName}${fileExtention} (${getFileSizeDisplay(
            props.chatPost.fileSize
        )})`;
        const content = [];
        if (props.chatPost.postType === Constant.POST_TYPE.IMAGE) {
                let dataDownload = getLinkFileChatPost(props.chatPost)
                content.push(
                    <div className="content-post">
                        <img 
                            src={dataDownload}
                            alt=''
                        />
                    </div>
                );
           
            content.push(<span style={{ display: 'block',wordBreak:'break-word' }}  > {fileNameAndSize} </span>);
        } else {
            content.push(fileNameAndSize);
        }
        let elementChild = (
            <a
                className={fileActive ? `${fileNameClass} file-upload-active` : fileNameClass}
                target="_blank"
                download={props.chatPost.content}
                onClick={() => (fileActive ? downloadFileFromS3(props.chatPost) : null)}
            >
                {content}
                {props.fileUploadInfor?.status === false && (
                    <WarningIcon color="error" size="small" />
                )}
            </a>
        );
        renderUploadFiles.push(elementChild);
        if (!Utils.isEmptyObject(props.fileUploadInfor) && props.fileUploadInfor.status) {
            renderUploadFiles.push(
                <LinearProgressWithLabel value={props.fileUploadInfor.progress} />
            );
        } 
        return renderUploadFiles;
    }
    return renderFileUpload();
};

export const getThumbnailByType = (fileUrl, type = Constant.ATTACH_FILE.SIZE_SMALL) => {
    let fileExtention = fileUrl.split('.').pop().toLocaleLowerCase();
    let fileUploadThumbnail = fileUrl;
    
    if (Constant.ATTACH_FILE_IMAGE_EXTENSIONS.split(',').includes(fileExtention)) {
        let positionDot = fileUrl.lastIndexOf('.');
        let uriFile = fileUrl.substring(0, positionDot);
        fileUploadThumbnail = uriFile + `_thumbnail_${type}.jpg`
    }

    return fileUploadThumbnail;
}



export const downloadFileFromS3 = async (fileUpload) => {
    let dataDownload = getLinkFileChatPost(fileUpload)
    const a = document.createElement('a');
    a.href = dataDownload;
    a.download = fileUpload.content;
    a.target = '_blank';
    a.click();
    a.remove();
};

const getLinkFileChatPost = fileUpload => {
    if (Utils.isEmptyString(fileUpload?.fileUrl)) {
        return;
    }
    const loadingThumbnail = '/assets/image/thumbnail.png';
    // if (!fileUpload.id && fileUpload.postType === Constant.POST_TYPE.IMAGE) {
    //     return loadingThumbnail;
    // }

    let s3Path = fileUpload.fileUrl;

    let uriObj = {};
    let projectList = [];
    let orgHasReadPermission = [];
    let userHasReadPermission = [];

    uriObj = {
        projectList,
        orgHasReadPermission,
        userHasReadPermission,
        keyFile: `/public/${s3Path}`,
        publicAll: true
    };

    const enCodeUriObj = encodeURIComponent(
        crypto.AES.encrypt(JSON.stringify(uriObj), Constant.S3_URL_AES_ENCODE_KEY).toString()
    );
    const newUri = `/${enCodeUriObj}`;
    return `${process.env.REACT_APP_CLOUD_FRONT_URL}${newUri}`;
};

const getFileSizeDisplay = (totalByte) => {
    if (!totalByte) return '0';
    if (totalByte < 1024) {
        return `${totalByte} bytes`;
    }
    let num = totalByte / 1024;
    if (totalByte < 1024 * 1024) {
        return `${Math.round(num * 100) / 100} KB`;
    }
    num = num / 1024;
    if (totalByte < 1024 * 1024 * 1024) {
        return `${Math.round(num * 100) / 100} MB`;
    }
    num = num / 1024;
    return `${Math.round(num * 100) / 100} GB`;
};


function UploadFileMessage({ message,fileUploading,fileUploadList }) {
    let fileUploadInfor = fileUploadList?.find(file => {
        return file.key === message.fileUrl
    });
    return (
        <div className="chatBox-text message-text">
            <div className="chatBoxContent">
                <span className="chatBox-label">
                    <span className="chatBox-txt">
                        <main>
                            <FileUploaded
                                key={message.content.fileUrl}
                                fileUploadInfor={
                                    typeof fileUploadInfor !== 'undefined' ? fileUploadInfor : null
                                }
                                fileUploading={fileUploading}
                                chatPost={message}
                                detailTicket={message}
                                isAlignLeft={message.isFromMe}
                            ></FileUploaded>
                        </main>
                    </span>
                </span>
            </div>
        </div>
    );
}

export default UploadFileMessage;
